import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useMediaQuery, useTheme } from '@mui/material';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import moment from 'moment';
import { dateTimeToView } from '../../../../utils/date.utils';
import { create_library_banner, library_banner_list, LibraryBannerApi } from '../../../../api/library-banner/library_banner.api';
import { Media_file_type } from '../../components/UploadAllFile';


export const useManageState = () => {
    // CONSTANCE
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname;
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));


    const [formState, setFormState] = useState<create_library_banner>({
        id_media_file: null,
        library_banner_name: "",
        library_seq: "",
        id_library_banner: null
    })
    const [media_file, set_media_file] = useState<Media_file_type | null>(null)

    // HOOKS
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);
    const [category_library, set_category_library] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);
    const [showModal, set_showModal] = useState<string>("");

    const handleCloseModal = () => {
        set_showModal("");
        set_media_file(null);
        setFormState({
            id_media_file: null, library_banner_name: "", library_seq: "",
            id_library_banner: null
        });
    }
    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_start_date(st);
        set_end_date(end);
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_library_banner", width: 50, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อ Banner")
        },
        {
            id: "4", disablePadding: false, align: "center", width: 141, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "5", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            library_banner_name,
            created_by,
            modified_date,
            modified_by,
            id_library_banner,
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "left",
                    label: library_banner_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => {
                                set_showModal("VIEW");
                                handleFindOne(id_library_banner);
                            }}
                            onEditClick={() => {
                                set_showModal("EDIT");
                                handleFindOne(id_library_banner);
                            }}
                            onDeleteClick={() => handleDeleteList(id_library_banner)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleFindOne = async (id_library_banner: number) => {
        dispatch(setLoading());
        await LibraryBannerApi.findOne(id_library_banner).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const media_file_data = response?.media_file as Media_file_type;
                set_media_file(media_file_data);
                setFormState({
                    id_library_banner: id_library_banner,
                    library_banner_name: response?.library_banner_name || "",
                    id_media_file: response?.id_media_file || null,
                    library_seq: response?.library_seq ? String(response?.library_seq) : ""
                });
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleDeleteList = (id_library_banner: number) => {
        alertActive("ลบรายการ", "ท่านต้องการลบรายการนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await LibraryBannerApi.delete(id_library_banner).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว");
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const generateBody = (): create_library_banner => {
        return {
            id_media_file: media_file?.id_media_file || null,
            library_seq: formState.library_seq,
            library_banner_name: formState.library_banner_name,
        }
    }

    const handleSubmit = async () => {
        const body = generateBody();
        dispatch(setLoading());
        if (formState.id_library_banner) {
            await LibraryBannerApi.update(formState.id_library_banner, body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    handleCloseModal();
                    alertSuccess("อัพเดตหมวดหมู่", "อัพเดตหมวดหมู่ สำเร็จ");
                }
            }).catch((err) => {
                console.log(err);
                alertError("อัพเดตหมวดหมู่", "อัพเดตหมวดหมู่ ไม่สำเร็จ");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {

            await LibraryBannerApi.create(body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    handleCloseModal();
                    alertSuccess("เพิ่มหมวดหมู่", "เพิ่มหมวดหมู่ สำเร็จ");
                }
            }).catch((err) => {
                console.log(err);
                alertError("เพิ่มหมวดหมู่", "เพิ่มหมวดหมู่ ไม่สำเร็จ");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
        // console.log(body, 'body');
    }

    const handleGetData = useCallback(async () => {
        let query: library_banner_list = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        if (search) query.search = search
        if (category_library) query.category_library = category_library
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.start_date = moment(end_date).format("YYYY-MM-DD");
        dispatch(setLoading());
        await LibraryBannerApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                set_data(response)
                // console.log(response, 'data')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, category_library, start_date, end_date, search])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        pathname,
        set_search,
        handleChangeDateRange,
        start_date,
        end_date,
        page,
        pageLimit,
        totalItems,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        showModal,
        handleCloseModal,
        set_showModal,
        handleSubmit,
        category_library,
        set_category_library,
        setFormState,
        formState,
        media_file,
        set_media_file
    }
}

